/* src/app/private/components/leads/find-duplicate-leads/find-duplicate-leads.component.scss */
.duplicate-leads-content {
  max-height: 70vh;
  overflow-y: auto;
}
:host ::ng-deep .p-dialog-header {
  background-color: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
}
:host ::ng-deep .p-table .p-datatable-thead > tr > th {
  background-color: #f8f9fa;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
}
:host ::ng-deep .p-table .p-datatable-tbody > tr {
  transition: background-color 0.2s;
}
:host ::ng-deep .p-table .p-datatable-tbody > tr:hover {
  background-color: #f8f9fa;
}
:host ::ng-deep .p-progressspinner {
  width: 50px;
  height: 50px;
}
/*# sourceMappingURL=find-duplicate-leads.component.css.map */
